import { useNavigate } from "react-router-dom";

import { Button } from "_imports/mui";

import { Paths } from "../constants";

import "./Header.css";

type Props = {
  userIdentifier?: string;
  showEdit?: boolean;
  showSaveIdInfo?: boolean;
  showUserName?: boolean;
  showSignOut?: boolean;
};

const Header = ({
  userIdentifier,
  showEdit = false,
  showSaveIdInfo = false,
  showUserName = false,
  showSignOut = false,
}: Props) => {
  const navigate = useNavigate();

  const onSignOut = () => {
    navigate(Paths.CREATE_ACCOUNT, { replace: true });
  };

  return (
    <div className="header">
      <div className="header-action">
        <div className="center">
          <img src="/logo-full.png" alt="logo" width={"auto"} height={96} />
        </div>
        <div style={{ textAlign: "right", color: "#0D1117" }}>
          <p>Oposiciones Radiofísica Hospitalaria</p>
          <p>Correción de Convocatoria Oficial</p>
          <p style={{ fontWeight: 600 }}>GMB Radiofísica</p>
        </div>
      </div>

      {(userIdentifier || showUserName || showSaveIdInfo || showEdit) && (
        <>
          <span className="header-separator" />
          <div className="header-action">
            <div className="center">
              {userIdentifier && showUserName && (
                <p className="user-id">{userIdentifier}</p>
              )}
              {userIdentifier && showSaveIdInfo && (
                <p className="user-id">
                  {`Bienvenido al Sistema de corrección del Grupo GMB, su identificador es el ${userIdentifier}`}
                </p>
              )}
              {showEdit && (
                <Button
                  variant="outlined"
                  onClick={() =>
                    navigate(Paths.SUBMIT_ANSWERS, { replace: true })
                  }
                >
                  Editar respuestas
                </Button>
              )}
            </div>
            {showSignOut && <Button onClick={onSignOut}>Cerrar sesión</Button>}
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
